// Hook to deal with mobileNavBar
import { mobileNavBarState } from "../context/mobileNavBarContext"

const useMobileNavBar = () => {

    const toggleMobileNav =  () => {
      mobileNavBarState.visible = !mobileNavBarState.visible
    }

    const showMobileNav = () => {
      mobileNavBarState.visible = true;
    }

    const hideMobileNav = () => {
      mobileNavBarState.visible = false;
    }

    return { toggleMobileNav, showMobileNav, hideMobileNav, mobileNavBarState };
}

export default useMobileNavBar
